export default "__VITE_PUBLIC_ASSET__9ad079db__"